var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0846 90.5238C39.5997 83.6374 49.2425 76.0484 70.4778 76.6244C47.6158 77.8702 42.9994 83.8747 47.0846 90.5238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4968 42.0053H61.6444V74.7908H71.3505V57.5089L84.451 75.3748L97.3774 57.675V87.5723L107.516 87.9216V42.0053H96.5628L84.5419 60.9877L72.0531 42.0053H66.4968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4981 42H61.6457V74.7855H71.3518V57.5089L84.4522 75.3747L97.3787 57.675V87.5722L107.517 87.9216V42H96.5641L84.5432 60.9824L72.0544 42H66.4981Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.986 101.309C144.24 104.047 138.353 105.563 130.253 106.219C132.876 106.497 139.713 106.498 137.944 107.84C130.193 113.718 92.0176 111.424 66.5126 103.47C38.7891 94.8251 37.4195 82.3983 45.5621 78.6756C55.7797 74.0025 78.0154 75.732 81.3769 75.9812C79.9664 76.6943 77.8282 76.7721 77.1507 78.1061C82.7226 76.4779 88.5435 75.8732 94.3311 76.3213C81.6742 74.3964 68.8582 73.7261 56.0697 74.3202C37.1268 75.2311 29.3625 86.2593 37.923 95.4645C65.3855 125.001 158.306 117.405 146.987 101.311",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2938 76.5902L61.6444 77.0068V86.8077H71.2938V76.5902Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.837 113.913C117.512 118.267 114.827 122.082 111.174 124.798C107.522 127.513 103.095 128.986 98.544 129H77.347V111.468C80.5687 112.088 83.8418 112.601 87.1216 113.011V120.976H98.5216C100.708 120.97 102.848 120.337 104.686 119.153C106.524 117.968 107.984 116.282 108.893 114.293C112.327 114.271 115.66 114.144 118.835 113.917M77.347 84.1567H98.544C104.16 84.173 109.542 86.4114 113.514 90.3828C117.485 94.3542 119.723 99.7359 119.74 105.352V107.807C119.737 108.573 119.693 109.339 119.608 110.101C116.576 110.101 113.321 109.969 109.915 109.735C109.915 109.68 109.915 109.626 109.915 109.571V104.298C109.906 101.277 108.702 98.3824 106.566 96.2464C104.43 94.1103 101.536 92.9065 98.515 92.8978H87.115V106.808C83.8102 106.195 80.5305 105.499 77.3404 104.729L77.347 84.1567Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0153 75.6501C-0.919708 85.9323 41.4097 109.615 68.457 114.026C20.4183 98.0283 25.7321 80.7635 43.0153 75.6501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.8a2b29b8e61b9f5d9a948f6de257158d.svg";
export { ForwardRef as ReactComponent };